import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing the filter view for auto-exclusion users.
 */
export default class FilterAutoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization function
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('ID is required'), // Validation message
                },
                {
                    view: 'richselect', // Dropdown for categories
                    name: 'Categorie',
                    localId: 'categorie:combo',
                    label: "<span class='icon-category'></span>" + _('Categorías'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for user creation
                    name: 'UserCreation',
                    label: "<span class='icon-folder-add'></span>" + _('Usuario Creación'),
                    labelPosition: 'top',
                    placeholder: _('Usuario Creación'),
                    invalidMessage: _('Usuario Creación is required'), // Validation message
                },
            ],
        };

        // Center left section of the form
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for subcategories
                    name: 'SubCategory',
                    localId: 'subCategorie:combo',
                    label: "<span class='icon-subcategory'></span>" + _('Sub Categoría'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for user modified
                    name: 'UserModified',
                    label: "<span class='icon-mode_edit'></span>" + _('Usuario Modificó'),
                    labelPosition: 'top',
                    placeholder: _('Usuario Modificó'),
                    invalidMessage: _('Usuario Modificó is required'), // Validation message
                },
            ],
        };

        // Center right section of the form
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for games
                    name: 'Game',
                    localId: 'game:combo',
                    label: "<span class='icon-games'></span>" + _('Juego'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Right section of the form
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for activation status
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'datepicker', // Datepicker for selecting date
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y',
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum date is today
                        },
                    },
                },
            ],
        };

        // Upper section combining all parts
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key triggers this button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            $$('Date').hide(); // Hide date input if typeDate is not 2
                            $$('Datepicker').show(); // Show datepicker
                        } else {
                            if (true) {
                                $$('Date').show(); // Show date input
                                $$('Datepicker').hide(); // Hide datepicker
                            }
                        }
                        this.app.callEvent('autoexclusionUsers:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
